import styled from "styled-components";

export const StyledTableDiv = styled.div`
    margin: 15px
`;
